import isEmpty from 'ramda/src/isEmpty'
import complement from 'ramda/src/complement'

export default ({ model, focalLength }) => {
  if (model && complement(isEmpty)(model.focalLength)) {
    return model.focalLength.max ? `${model.focalLength.min} - ${model.focalLength.max}mm` : `${model.focalLength.min}mm`
  } else {
    return `${focalLength}mm`
  }
}



// WEBPACK FOOTER //
// ./src/helpers/cameras/getFocalLength.js